import { render, staticRenderFns } from "./Total_power_consumption.vue?vue&type=template&id=686f378a&scoped=true&"
import script from "./Total_power_consumption.vue?vue&type=script&lang=js&"
export * from "./Total_power_consumption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f378a",
  null
  
)

export default component.exports